import { render, staticRenderFns } from "./PensionInfo.vue?vue&type=template&id=0ed8ed54&scoped=true&"
import script from "./PensionInfo.vue?vue&type=script&lang=js&"
export * from "./PensionInfo.vue?vue&type=script&lang=js&"
import style0 from "./PensionInfo.vue?vue&type=style&index=0&id=0ed8ed54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed8ed54",
  null
  
)

export default component.exports